import React, { Component } from 'react';
import '../App.css';

// Custom Components
import AppItem from '../components/AppItem';
import VideoHero from './VideoHero';
import DaltonCard from './DaltonCard'
import Slider from './Slider'

// Hero Image
// import me from '../img/me-min.png'
import hero_video from "../img/hero_video.mp4"


//Brand Images
var bassPro = require('../img/bassPro.png')
var invo = require('../img/invo.png')
var MSU = require('../img/MSU.png')
var midwestern = require('../img/midwestern.png')
var powerShades = require('../img/powerShades.png')


class AppShowcase extends Component {
state = {
  headerShrink: false,
  daltonGrow: false,
}


componentDidMount() {
  window.addEventListener('scroll', this.shrinkHero);
  window.addEventListener('scroll', this.daltonGrow);
}

componentWillUnmount() {
  window.removeEventListener('scroll', this.shrinkHero);
  window.removeEventListener('scroll', this.daltonGrow);
}

shrinkHero = (e) => {
  if(window.scrollY < 50){
    this.setState({
      headerShrink: false,
    })
  }else{
    this.setState({
      headerShrink: true,
    })
  }
}

growDalton = (e) => {
  if(window.scrollY > 150){
    this.setState({
      daltonGrow: true,
    })
  }else{
    this.setState({
      daltonGrow: false,
    })
  }
}
  render() {
    return (
      <div 
        className='apps-container polka' 
      >
        <div>
            <VideoHero
              homePage={true}
              addClass={this.state.headerShrink ? "shrunkHero" : ""}
              darkArrow={true}
              innherBackgroundColor={"#FFF"}
              video={hero_video}
            />
                <DaltonCard/>
                <div className={"slider-card-wrapper"}>
                  <h2 className={"slider-card-title"}>Professional Work</h2>
                    <Slider>
                      <AppItem
                        navLink={"./basspro"}
                        addClass={"bass-pro-tile"}
                        backgroundColor={"#223529"}
                        imgSrc={bassPro}
                      />  
                      <AppItem
                        navLink={"./invo"}
                        addClass={"invo-tile"}
                        backgroundColor={"#337EF2"}
                        imgSrc={invo}
                      />
                      <AppItem
                        navLink={"./msu"}
                        addClass={" msu-tile"}
                        backgroundColor={"#5A000A"}
                        imgSrc={MSU}
                      />
                      <AppItem
                        navLink={"./midwestern"}
                        addClass={" midwestern-tile"}
                        backgroundColor={"black"}
                        imgSrc={midwestern}
                      />
                      <AppItem
                        navLink={"./powershades"}
                        addClass={"ps-tile"}
                        backgroundColor={"#EEE"}
                        imgSrc={powerShades}
                      />
                    </Slider>
              </div>
            
        </div>
    </div>
    );
  }
}

export default AppShowcase;






// WEBPACK FOOTER //
// ./src/components/AppShowcase.js